module.exports = __webpack_public_path__ + "static/media/illustration-elements.193948b4.svg";